import { Button, Flex, Input, Modal, Typography } from "antd";
import {
  ExclamationCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import pallete from "../../../utils/pallete";
import { MODAL_MESSAGES } from "../constants";
import DocumentPreviewModal from "../../../components/DocumentPreviewModal";

export default function VerificationModals({
  previewDoc,
  setPreviewDoc,
  confirmVerify,
  setConfirmVerify,
  confirmRevise,
  setConfirmRevise,
  reviseNote,
  setReviseNote,
  confirmReject,
  setConfirmReject,
  rejectReason,
  setRejectReason,
  verificationType,
  isVerifying,
  isRevising,
  isRejecting,
  handleVerifyMutation,
  handleReviseMutation,
  handleRejectMutation,
}) {
  return (
    <>
      {/* Modal Preview Dokumen */}
      <DocumentPreviewModal
        open={previewDoc.length > 0}
        src={previewDoc}
        title="Preview Dokumen"
        onClose={() => {
          if (previewDoc.startsWith("blob:")) URL.revokeObjectURL(previewDoc);
          setPreviewDoc("");
        }}
      />

      {/* Modal Konfirmasi Verifikasi */}
      <Modal
        open={confirmVerify}
        centered
        footer={null}
        closable={false}
        width={400}
        onCancel={() => !isVerifying && setConfirmVerify(false)}
      >
        <Flex vertical align="center" justify="center" gap={12}>
          <div
            style={{
              backgroundColor: "#F6FFED",
              borderRadius: "50%",
              padding: 16,
            }}
          >
            <CheckCircleFilled style={{ color: "#52C41A", fontSize: 32 }} />
          </div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {MODAL_MESSAGES.VERIFY.TITLE}
          </Typography.Title>
          <Typography.Text style={{ textAlign: "center" }}>
            {MODAL_MESSAGES.VERIFY.DESCRIPTION}
          </Typography.Text>
          <Flex gap={8} style={{ marginTop: 16 }}>
            <Button
              onClick={() => setConfirmVerify(false)}
              disabled={isVerifying}
            >
              Batal
            </Button>
            <Button
              type="primary"
              style={{ backgroundColor: pallete.primary[500] }}
              onClick={() => handleVerifyMutation(verificationType)}
              loading={isVerifying}
            >
              Terima
            </Button>
          </Flex>
        </Flex>
      </Modal>

      {/* Modal Konfirmasi Revisi */}
      <Modal
        open={confirmRevise}
        centered
        footer={null}
        closable={false}
        width={450}
        onCancel={() => !isRevising && setConfirmRevise(false)}
      >
        <Flex vertical align="center" justify="center" gap={12}>
          <div
            style={{
              backgroundColor: "#FFF4E5",
              borderRadius: "50%",
              padding: 16,
            }}
          >
            <ExclamationCircleFilled
              style={{ color: "#FAAD14", fontSize: 32 }}
            />
          </div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {MODAL_MESSAGES.REVISE.TITLE}
          </Typography.Title>
          <Typography.Text style={{ textAlign: "center" }}>
            {MODAL_MESSAGES.REVISE.DESCRIPTION}
          </Typography.Text>
          <div style={{ width: "100%", marginTop: 12 }}>
            <Typography.Text strong>
              {MODAL_MESSAGES.REVISE.REASON_LABEL}
            </Typography.Text>
            <Input.TextArea
              rows={4}
              value={reviseNote}
              onChange={(e) => setReviseNote(e.target.value)}
              placeholder={MODAL_MESSAGES.REVISE.REASON_PLACEHOLDER}
              disabled={isRevising}
              maxLength={500}
              showCount
            />
          </div>
          <Flex gap={8} style={{ marginTop: 16 }}>
            <Button
              onClick={() => {
                setConfirmRevise(false);
                setReviseNote("");
              }}
              disabled={isRevising}
            >
              Batal
            </Button>
            <Button
              style={{ backgroundColor: "#FAAD14", color: "white" }}
              onClick={() => handleReviseMutation(reviseNote)}
              loading={isRevising}
            >
              Kirim
            </Button>
          </Flex>
        </Flex>
      </Modal>

      {/* Modal Konfirmasi Tolak */}
      <Modal
        open={confirmReject}
        centered
        footer={null}
        closable={false}
        width={450}
        onCancel={() => !isRejecting && setConfirmReject(false)}
      >
        <Flex vertical align="center" justify="center" gap={12}>
          <div
            style={{
              backgroundColor: "#FFF1F0",
              borderRadius: "50%",
              padding: 16,
            }}
          >
            <CloseCircleFilled style={{ color: "#FF4D4F", fontSize: 32 }} />
          </div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {MODAL_MESSAGES.REJECT.TITLE}
          </Typography.Title>
          <Typography.Text style={{ textAlign: "center" }}>
            {MODAL_MESSAGES.REJECT.DESCRIPTION}
          </Typography.Text>
          <div style={{ width: "100%", marginTop: 12 }}>
            <Typography.Text strong>
              {MODAL_MESSAGES.REJECT.REASON_LABEL}
            </Typography.Text>
            <Input.TextArea
              rows={4}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder={MODAL_MESSAGES.REJECT.REASON_PLACEHOLDER}
              disabled={isRejecting}
              maxLength={500}
              showCount
            />
          </div>
          <Flex gap={8} style={{ marginTop: 16 }}>
            <Button
              onClick={() => {
                setConfirmReject(false);
                setRejectReason("");
              }}
              disabled={isRejecting}
            >
              Batal
            </Button>
            <Button
              danger
              type="primary"
              onClick={() => handleRejectMutation(rejectReason)}
              loading={isRejecting}
            >
              Kirim
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}
